module.exports = __webpack_public_path__ + "img/d723a95406621eb26acb7b4b6eebdb8f.png";